<template>
  <div class="col-12 col-md-3 left-menu mb-3">
    <CommunityCard :withHorizontalRules="false">
      <div class="isim-community-card-header">
        <h5 class="m-0">My Profile</h5>
      </div>

      <ul class="list-group">
        <router-link to="/me/">
          <li
            class="list-group-item d-flex align-items-center"
            v-bind:class="{ active: onProfile }"
          >
            <img
              class="mr-2"
              width="24"
              height="24"
              :src="
                onProfile
                  ? require('../assets/nav-icons/my-profile-fill.svg')
                  : require('../assets/nav-icons/my-profile.svg')
              "
              alt="icon"
            />
            My Profile
          </li>
        </router-link>
        <router-link to="/me/profile">
          <li
            class="list-group-item d-flex align-items-center"
            v-bind:class="{ active: onEditDetails }"
          >
            <img
              class="mr-2"
              width="24"
              height="24"
              :src="
                onEditDetails
                  ? require('../assets/nav-icons/update-details-fill.svg')
                  : require('../assets/nav-icons/update-details.svg')
              "
              alt="icon"
            />
            Update details
          </li>
        </router-link>
        <router-link to="/me/password">
          <li
            class="list-group-item d-flex align-items-center"
            v-bind:class="{ active: onPassword }"
          >
            <img
              class="mr-2"
              width="24"
              height="24"
              :src="
                onPassword
                  ? require('../assets/nav-icons/change-password-fill.svg')
                  : require('../assets/nav-icons/change-password.svg')
              "
              alt="icon"
            />
            Change password
          </li>
        </router-link>
      </ul>
      <hr />
      <div class="isim-community-card-header">
        <h5 class="m-0">My Content</h5>
      </div>
      <ul class="list-group">
        <router-link to="/me/media">
          <li
            class="list-group-item d-flex align-items-center"
            v-bind:class="{ active: onMedia }"
          >
            <img
              class="mr-2"
              width="24"
              height="24"
              :src="
                onMedia
                  ? require('../assets/nav-icons/my-media-fill.svg')
                  : require('../assets/nav-icons/my-media.svg')
              "
              alt="icon"
            />
            My media
          </li>
        </router-link>

        <router-link to="/me/scenarios">
          <li
            class="list-group-item scenarios d-flex"
            v-bind:class="{ active: onScenarios }"
          >
            <img
              class="mr-2"
              width="24"
              height="24"
              :src="
                onScenarios
                  ? require('../assets/nav-icons/my-scenarios-fill.svg')
                  : require('../assets/nav-icons/my-scenarios.svg')
              "
              alt="icon"
            />
            <div class="flex-grow-1" style="min-width: 0">
              My scenarios
              <ScenarioDirectoryTreeContainer v-if="onScenarios" />
            </div>
          </li>
        </router-link>

        <router-link to="/me/forum/groups">
          <li
            class="list-group-item d-flex align-items-center"
            v-bind:class="{ active: onForumGroups }"
          >
            <img
              class="mr-2"
              width="24"
              height="24"
              :src="
                onForumGroups
                  ? require('../assets/nav-icons/my-groups-fill.svg')
                  : require('../assets/nav-icons/my-groups.svg')
              "
              alt="icon"
            />
            My groups
          </li>
        </router-link>
      </ul>
      <div v-if="user.canProvision" class="my-3">
        <hr />
        <div class="isim-community-card-header">
          <h5 class="m-0">Provisioning</h5>
        </div>
        <ul class="list-group">
          <router-link to="/me/provisioning">
            <li
              class="list-group-item d-flex align-items-center"
              v-bind:class="{ active: onProvisioning }"
            >
              <img
                class="mr-2"
                width="24"
                height="24"
                :src="
                  onProvisioning
                    ? require('../assets/nav-icons/provision-device-fill.svg')
                    : require('../assets/nav-icons/provision-device.svg')
                "
                alt="icon"
              />
              Provision device
            </li>
          </router-link>
        </ul>
      </div>
      <div v-if="user.isPreRelease" class="my-3">
        <hr />

        <div class="isim-community-card-header">
          <h5 class="m-0">Pre-Release</h5>
        </div>
        <ul class="list-group">
          <router-link to="/me/pre-release">
            <li
              class="list-group-item d-flex align-items-center"
              v-bind:class="{ active: onPreReleases }"
            >
              <i class="material-icons mr-2"> new_releases </i>
              View pre-releases
            </li>
          </router-link>
        </ul>
      </div>
      <hr />

      <div class="isim-community-card-header">
        <h5 class="m-0">Resources</h5>
      </div>
      <ul class="list-group">
        <router-link to="/me/downloads">
          <li
            class="list-group-item d-flex align-items-center"
            v-bind:class="{ active: onDownloads }"
          >
            <img
              class="mr-2"
              width="24"
              height="24"
              :src="
                onDownloads
                  ? require('../assets/nav-icons/available-downloads-fill.svg')
                  : require('../assets/nav-icons/available-downloads.svg')
              "
            />
            Available downloads
          </li>
        </router-link>
      </ul>
      <hr />

      <div class="isim-community-card-header">
        <h5 class="m-0">Support</h5>
      </div>
      <ul class="list-group mb-2">
        <router-link to="/me/support">
          <li
            class="list-group-item d-flex align-items-center"
            v-bind:class="{ active: onSupport }"
          >
            <img
              class="mr-2"
              width="24"
              height="24"
              :src="
                onSupport
                  ? require('../assets/nav-icons/support-information-fill.svg')
                  : require('../assets/nav-icons/support-information.svg')
              "
              alt="icon"
            />
            Support information
          </li>
        </router-link>
      </ul>
    </CommunityCard>
  </div>
</template>

<script>
import CommunityCard from "../components/CommunityCard";
import ScenarioDirectoryTreeContainer from "@/components/ScenarioDirectoryTree/ScenarioDirectoryTreeContainer";

export default {
  name: "UserMenu",
  components: {
    ScenarioDirectoryTreeContainer,
    CommunityCard,
  },
  computed: {
    deviceInfo() {
      return this.$store.getters.getDeviceInfo;
    },
    user() {
      return this.$store.getters.getUser;
    },
  },
  data() {
    return {
      onProfile: false,
      onPassword: false,
      onEditDetails: false,
      onUploadScenario: false,
      onCreateGroup: false,
      onScenarios: false,
      onUploadMedia: false,
      onMedia: false,
      onForumGroups: false,
      onProvisioning: false,
      onSupport: false,
      onDownloads: false,
      onPreReleases: false,
    };
  },
  beforeMount() {
    switch (this.$route.name) {
      case "my-profile":
        this.onProfile = true;
        break;
      case "my-profile-details":
        this.onEditDetails = true;
        break;
      case "my-password":
        this.onPassword = true;
        break;
      case "scenarios-upload":
        this.onUploadScenario = true;
        break;
      case "create-forum-group":
        this.onCreateGroup = true;
        break;
      case "my-scenarios":
        this.onScenarios = true;
        break;
      case "media-upload":
        this.onUploadMedia = true;
        break;
      case "my-media":
        this.onMedia = true;
        break;
      case "my-forum-groups":
        this.onForumGroups = true;
        break;
      case "provisioning":
        this.onProvisioning = true;
        break;
      case "my-support":
        this.onSupport = true;
        break;
      case "my-pre-release":
        this.onPreReleases = true;
        break;
      default:
        this.onProfile = true;
        break;
    }
  },
};
</script>

<style scoped>
.list-group-item.active {
  color: var(--isim-primary);
}
@media (min-width: 992px) {
  .list-group-item a {
    color: #333;
  }
  .list-group-item {
    color: #212529;
  }
}

ul.list-group li:not(:first-child a):not(:last-child a) {
  border-radius: 0;
}

ul.list-group li :first-child a {
  border-bottom-left-radius: 0;
}

ul.list-group li:last-child a {
  border-top-left-radius: 0;
}

.list-group-item {
  border: none;
  margin-bottom: 5px;
  color: var(--isim-light-text);
  margin-left: 0;
  background: inherit;
  max-height: 2.2rem;
}

.list-group-item.scenarios {
  max-height: none;
}
</style>
